import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import './InviteHomeBottom.scss'
import recordImg from '../../assets/images/invite/expandRecord@2x.png'

class InviteHomeBottom extends Component{
  render() {
    return (
      <div className='new-invite-home-custom-bottom'>
        <div className="new-invite-home-custom-bottom-left" onClick={this.goToInviteShareList}>
          <img src= {recordImg} alt=""/>
          <p>推广记录</p>
        </div>
        <div className="new-invite-home-custom-bottom-right" onClick={this.props.expandFunc}>
          <p>{this.props.expandStr}</p>
        </div>
      </div>
    )
  }
  goToInviteShareList = () => {
    console.log(this.props.productID);
    this.props.history.push({
      pathname :"/InviteShareList",
      state: {
        productID: this.props.productID,
      }
    });
  }
}

InviteHomeBottom.propTypes = {
  expandFunc: PropTypes.func.isRequired,
  expandStr: PropTypes.string.isRequired,
  productID: PropTypes.string.isRequired,
}

export default withRouter(InviteHomeBottom)
